import { Badge, Box, NavList } from '@deckee/deck-hand';
import React, { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { callEndpoint } from '../../../../services/backend';
import { selectUnitsConfig } from '../../../../services/store/modules/app-controls';
import { formatLatLon } from '../../../helpers/coordinate-helpers';
import IconWithTextLockup from '../../../lockups/IconWithTextLockup/IconWithTextLockup';
import BlueCircleWrapper from '../../../shared/BlueCircleWrapper/BlueCircleWrapper';
import { ReactSvg, rules } from '../../../shared/vector-images';

export interface RegulationCardInterface {
  latitude: number;
  longitude: number;
  showLatLon?: boolean;
  chevron?: boolean;
  onClick?: () => void;
  blueVersion?: boolean;
}
const RegulationLocationCard: FC<RegulationCardInterface> = ({
  latitude,
  longitude,
  onClick,
  showLatLon,
  chevron,
  blueVersion,
}) => {
  const [regulationsCount, setRegulationsCount] = useState(0);
  const unitsConfig = useSelector(selectUnitsConfig);

  const theme = useTheme();

  useEffect(() => {
    const updateRegulationsCount = async () => {
      if (latitude && longitude) {
        setRegulationsCount(
          await callEndpoint(
            callEndpoint.endpoints.getRegulationsCountByLocation,
            {
              ':latitude': latitude,
              ':longitude': longitude,
            },
          ),
        );
      }
    };
    updateRegulationsCount();
  }, [latitude, longitude]);

  const Wrapper = blueVersion ? BlueCircleWrapper : React.Fragment;

  return (
    <NavList.Item onClick={onClick} chevron={chevron}>
      <IconWithTextLockup
        image={
          <Wrapper>
            <ReactSvg
              toDisplay={rules()}
              options={{
                fillColor: blueVersion
                  ? theme.colors.secondary
                  : theme.colors.primary,
              }}
              width={24}
              height={24}
            />
          </Wrapper>
        }
        heading="Regulations in this area"
      >
        {latitude && longitude && showLatLon && (
          <Box fontSize="1" color="darkergrey" mt="1">
            {formatLatLon(unitsConfig?.coordinate, latitude, longitude)}
          </Box>
        )}
      </IconWithTextLockup>
      <Badge ml="auto">{regulationsCount}</Badge>
    </NavList.Item>
  );
};

RegulationLocationCard.defaultProps = {
  showLatLon: true,
  chevron: true,
  blueVersion: false,
  // Allow nothing to happen on click unless overridden
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick: () => {},
};

export default RegulationLocationCard;
